module.exports = __webpack_public_path__ + "static/media/tempTemplate3.158383bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Templates/tempTemplate3.png
// module id = 496
// module chunks = 0